import { SmartContractSvg } from '../../../assets';
import {
    noSpaceAllowedInSchemaTest,
    themeObject,
    validationsMessages,
} from 'lib';
import * as yup from 'yup';

export const SUCCESS_MESSAGE = 'Contract executed successfully.';

export interface CreateOrUpdateSmartContractFormData {
    name: string;
    description: string;
    javaScript: string;
}

export const CreateOrUpdateSmartContractSchema = yup.object({
    name: noSpaceAllowedInSchemaTest(
        yup.string().required(validationsMessages.required),
        'Enter a valid name.'
    ),
    description: noSpaceAllowedInSchemaTest(
        yup.string(),
        'Enter a valid description.'
    ),
    javaScript: noSpaceAllowedInSchemaTest(
        yup.string().required(validationsMessages.required),
        'Enter a valid javaScript.'
    ),
});

export const createOrUpdateSmartContractDefaults = {
    name: '',
    description: '',
    javaScript: '',
};

interface SmartContractConfig {
    [key: string]: {
        imgSrc: string;
        headingText?: string;
        iconStyles?: React.CSSProperties;
    };
}

export const smartContractConfig: SmartContractConfig = {
    'smart-contracts': {
        imgSrc: SmartContractSvg,
        headingText: 'New Smart Contract',
        iconStyles: {
            width: '70px',
            height: '72.42px',
        },
    },
};

export const executeSmartContractConfig: SmartContractConfig = {
    'smart-contracts': {
        imgSrc: SmartContractSvg,
        headingText: 'Execute Contract',
        iconStyles: {
            width: '70px',
            height: '72.42px',
        },
    },
};

export const createOrUpdateSmartContractStyles = {
    containerStyles: {
        mx: '143.5px',
        mt: '20px',
    },
    textFieldContainerStyles: {
        width: '100%',
        '& .MuiFormControl-root': {
            width: '100%',
        },
    },
    gridContainerStyles: {
        mt: 2,
        '& .MuiFormControl-root': {
            width: '100%',
        },
    },
    javaScript: {
        border: `1px solid ${themeObject.palette.grayScale[300]}`,
        borderRadius: '2px',
        boxShadow: 'none',
    },
    javaScriptError: {
        border: `1px solid ${themeObject.palette.tertiary.red[300]}`,
        borderRadius: '2px',
        boxShadow: 'none',
    },
    javaScriptErrorContainer: {
        paddingTop: '2px',
    },
    updateContainerStyles: {
        p: '25px 39px 26px 39px',
        backgroundColor: themeObject.palette.background.default,
        border: `1px solid ${themeObject.palette.grayScale[300]}`,
        width: '100%',
        borderRadius: '5px',
        mt: '24px',
    },
    smartContractTextContainerStyles: {
        mt: '24px',
    },
    smartContractTextStyles: {
        ...themeObject.typography.h3,
        fontSize: '24px',
        lineHeight: '28.18px',
        color: themeObject.palette.primary[700],
    },
    smartContractFieldContainerStyles: {
        p: '28.43px 31px 31.57px 31px',
        backgroundColor: themeObject.palette.background.default,
        border: `1px solid ${themeObject.palette.grayScale[300]}`,
        width: '100%',
        borderRadius: '5px',
        mt: '12px',
    },
    fabButtonStyles: {
        borderRadius: '64px',
        width: '220px',
        height: '40px',
        padding: '8px 16px',
        '& .MuiTypography-root': {
            fontFamily: 'Red Hat Text',
            fontSize: '14px',
            fontWeight: 700,
            lineHeight: '24px',
            color: themeObject.palette.grayScale[700],
            ml: '4px',
        },
    },
    fabButtonIconStyles: {
        height: '20px',
        width: '22.12px',
        color: themeObject.palette.tertiary.purple[300],
    },
    labelContainerStyles: {
        display: 'flex',
        alignItems: 'end',
    },
    labelAndButtonContainerStyles: {
        display: 'flex',
        justifyContent: 'space-between',
        mb: '12px',
    },
    codeMirrorHeight: '380px',
};
